import { useQuery } from 'react-query';
import { baseApiUrl, fetcher, ServerErrorResponse } from 'data_sources/constants';
import { ManualMetricItem } from '../../_types/policy';
import _ from 'lodash';

export const getManualMetrics = async (
  orgId: string,
  params: Record<string, any> = {},
  signal?: AbortSignal,
  onError?: (errors: ServerErrorResponse) => void,
) => {
  const url = `${baseApiUrl()}/activity-center/v1/organizations/${orgId}/policy/manual-metrics`;

  const paramString = new URLSearchParams(
    Object.entries({
      ...params,
    })
      .filter(([_k, v]) => !_.isEmpty(v))
      .reduce((acc, [k, v]) => ({ ...acc, [k]: v }), {}),
  ).toString();

  try {
    const metrics = await fetcher({
      method: 'get',
      url: `${url}?${paramString}`,
      options: { signal },
    });
    return metrics;
  } catch (error: unknown) {
    if (onError && typeof error === 'object' && error !== null && 'errorDetails' in error) {
      onError(error as ServerErrorResponse);
    }
    console.warn('error retrieving manual metrics');
    throw error;
  }
};

export default function useManualMetrics(
  orgId: string,
  params: Record<string, any> = {},
  options = {},
  onError?: (errors: ServerErrorResponse) => void,
) {
  return useQuery<ManualMetricItem[], Error>(
    ['manual_metrics', orgId, params],
    async ({ signal }): Promise<ManualMetricItem[]> => {
      return getManualMetrics(orgId, params, signal, onError);
    },
    {
      ...options,
      enabled: !!orgId,
      keepPreviousData: true,
      refetchOnWindowFocus: true,
      refetchInterval: 1000 * 60 * 15, // 15 minutes
    },
  );
}
